/**
 * Internal primitive behind `HttpRequest.setId()` and `UrlBuilder.setId()`. Substitutes each
 * `:id` segment, left to right, with the provided ids. Not exported from the `@lib/utils` barrel;
 * app code should call `.setId()` on the http or url builder instead.
 */
export function setUrlPathParams(url: string, ...ids: (string | number)[]): string {
  return ids.reduce((newUrl: string, id) => newUrl.replace(/:id/, id.toString()), url);
}
